export default {
  // last trip data
  id: '',
  status: '',

  // whole object
  user: {},
  lastTrip: {},
}
